import { makeStyles } from "@material-ui/styles";

export default makeStyles((theme: any) => ({
  actionToolbar: {
    width: '100%',
    height: 'auto',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '1rem'
  },
  actionBarTitle: {
    alignSelf: 'flex-start'
  },
  actionToolbarActions: {
    alignSelf: 'flex-end',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    '& > *': {
      padding: theme.spacing(1)
    }
  }
}));
